module.exports = __webpack_public_path__ + "img/baoxian.6f81144f.png";